export const INDUSTRIES = [
    { value: 'ecomerce', label: 'Ecommerce (TMĐT, Tiki, Lazada, Shopee,...)' },
    { value: 'education', label: 'Education (Giáo dục, Elearning, EdTech)' },
    { value: 'fintech', label: 'Fintech (Thanh toán, P2P Lending, Đầu tư)' },
    {
        value: 'cryptocurrentcy',
        label: 'Cryptocurrency (Sàn giao dịch, Blockchain)',
    },
    {
        value: 'logistics',
        label: 'Logistics & Transport (Vận chuyển, Giao nhận, Kho bãi)',
    },
    {
        value: 'manufacturing',
        label: 'Manufacturing (Sản xuất, FMCG, Công nghiệp)',
    },
    {
        value: 'healthcare',
        label: 'Healthcare (Dược phẩm, Bệnh viện, Y tế, Mỹ phẩm)',
    },
    {
        value: 'services',
        label: 'Services (Du lịch, Khách sạn, Tư vấn, Pháp lý)',
    },
    { value: 'multimedia', label: 'Multimedia (Tin tức, OTT, MXH, Quảng cáo)' },
    {
        value: 'technology',
        label: 'Technology (Phần mềm, Outsource, AI, SaaS)',
    },
    { value: 'game', label: 'Game (Web/App Game, Game NFT)' },
    { value: 'real-estate', label: 'Real Estate (PropTech, BĐS)' },
    { value: 'retail', label: 'Retail (Bán lẻ, Phân phối, Bán buôn)' },
    { value: 'energy', label: 'Energy (Năng lượng, Dầu khí, Điện nước)' },
    {
        value: 'agriculture',
        label: 'Agriculture (Nông nghiệp, Thuỷ sản, AgriTech)',
    },
    {
        value: 'construction',
        label: 'Construction (Xây dựng, Kiến trúc, Vật liệu)',
    },
    { value: 'insurance', label: 'Insurance (Bảo hiểm)' },
    { value: 'securities', label: 'Securities (Chứng khoán)' },
    { value: 'airlines', label: 'Airlines (Hàng không)' },
    { value: 'bank', label: 'Bank (Ngân hàng)' },
    { value: 'telecom', label: 'Telecom (Viễn thông, ISP)' },
    { value: 'goverment', label: 'Government (Cơ quan nhà nước)' },
    { value: 'automotive', label: 'Automotive (Ô tô, Xe máy, Phụ tùng)' },
    {
        value: 'media-entertainment',
        label: 'Media & Entertainment (Giải trí, Sự kiện, Phim ảnh)',
    },
    {
        value: 'food-beverage',
        label: 'F&B (Nhà hàng, Quán cà phê, Chuỗi đồ uống)',
    },
    { value: 'fashion', label: 'Fashion & Beauty (Thời trang, Làm đẹp)' },
    {
        value: 'hr-recruitment',
        label: 'HR & Recruitment (Nhân sự, Tuyển dụng)',
    },
    { value: 'legal', label: 'Legal (Luật, Công chứng, Pháp lý)' },
    {
        value: 'accounting-audit',
        label: 'Accounting & Audit (Kế toán, Kiểm toán)',
    },
    { value: 'ngo', label: 'NGO (Tổ chức phi lợi nhuận, Hiệp hội)' },
    { value: 'defense', label: 'Defense & Security (Quốc phòng, An ninh)' },
    {
        value: 'sports-fitness',
        label: 'Sports & Fitness (Thể thao, Gym, Wellness)',
    },
    { value: 'pet', label: 'Pet & Veterinary (Thú cưng, Thú y)' },
    { value: 'environment', label: 'Environment (Môi trường, Xử lý rác thải)' },
    {
        value: 'printing-packaging',
        label: 'Printing & Packaging (In ấn, Bao bì)',
    },
    { value: 'others', label: 'Others (Khác)' },
]

// For create/update forms — exclude legacy "others" value
export const INDUSTRY_OPTIONS = INDUSTRIES.filter((i) => i.value !== 'others')

export const CUSTOMER_SOURCES = (t: Function) => [
    // Marketing
    { value: 'form', label: t('customers.sources.forms') },
    { value: 'event', label: t('customers.sources.event') },
    { value: 'livechat', label: t('customers.sources.livechat') },
    { value: 'hotline', label: t('customers.sources.hotline') },
    { value: 'email', label: t('customers.sources.email') },
    { value: 'gg_ads', label: t('customers.sources.gg_ads') },
    { value: 'fb_ads', label: t('customers.sources.fb_ads') },
    // Legacy
    {
        value: 'marketing_approach',
        label: `${t('customers.sources.marketing_approach')} (${t('old')})`,
    },
    // Sale
    { value: 'research', label: t('customers.sources.research') },
    { value: 'contact', label: t('customers.sources.contact') },
    { value: 'sale_event', label: t('customers.sources.sale_event') },
]

export const CUSTOMER_SOURCE_TYPES = (t: Function) => [
    { value: 'internal', label: t('customers.sources.internal') },
    { value: 'external', label: t('customers.sources.external') },
]

export const CUSTOMER_JOURNEYS = (t: Function) => [
    { value: 'searching', label: t('journeys.contact_and_searching') },
    {
        value: 'presentation',
        label: t('journeys.meeting'),
    },
    { value: 'poc', label: t('journeys.poc') },
    { value: 'contract', label: t('journeys.deal_and_contract') },
    { value: 'close_win', label: t('journeys.close_win') },
    { value: 'close_lose', label: t('journeys.close_lose') },
    { value: 'terminate', label: t('journeys.terminate') },
]

export const CUSTOMER_JOURNEY_STATUS = (t: Function) => [
    {
        value: 'processing',
        label: t('processing'),
        textColor: '#4C57A9',
        bgcolor: '#4C57A91F',
    },
    {
        value: 'completed',
        label: t('completed'),
        textColor: '#66BB6A',
        bgcolor: '#66BB6A1F',
    },
    {
        value: 'pending',
        label: t('pending'),
        textColor: '#EF5350',
        bgcolor: '#EF53501F',
    },
    {
        value: 'skip',
        label: t('skip'),
        textColor: '#777680',
        bgcolor: '#7776801F',
    },
]

export const CONTACT_LABELS = (t: Function) => [
    {
        label: t('labels.contact-first', { ns: 'customer' }),
        value: 'contact-first',
    },
    //Liên hệ hành chính / hồ sơ:
    {
        label: t('labels.contact-administrative', { ns: 'customer' }),
        value: 'contact-administrative',
    },
    //Liên hệ kinh doanh:
    {
        label: t('labels.contact-business', { ns: 'customer' }),
        value: 'contact-business',
    },
    // Nhóm 3: Liên hệ tài chính / kế toán
    {
        label: t('labels.contact-financial', { ns: 'customer' }),
        value: 'contact-financial',
    },
    //Liên hệ kỹ thuật:
    {
        label: t('labels.contact-technical', { ns: 'customer' }),
        value: 'contact-technical',
    },
    //Liên hệ marketing:
    {
        label: t('labels.contact-marketing', { ns: 'customer' }),
        value: 'contact-marketing',
    },
    //Liên hệ khác:
    {
        label: t('labels.contact-other', { ns: 'customer' }),
        value: 'contact-other',
    },
]

export const CONTACT_ROLE_OPTIONS = (t: Function) => [
    {
        label: t('contact_roles.customer', { ns: 'customer' }),
        value: 'customer',
    },
    {
        label: t('contact_roles.supplier', { ns: 'customer' }),
        value: 'supplier',
    },
    {
        label: t('contact_roles.reseller', { ns: 'customer' }),
        value: 'reseller',
    },
    {
        label: t('contact_roles.collaborator', { ns: 'customer' }),
        value: 'collaborator',
    },
    {
        label: t('contact_roles.affiliate', { ns: 'customer' }),
        value: 'affiliate',
    },
]

export const CUSTOMER_STATUS = {
    COOLLEAD: 'cool-lead',
    DEADLEAD: 'dead-lead',
    POC: 'poc',
    QUALIFIED_PROSPECTS: 'qualified-prospect',
    TRIAL: 'trial',
    STOP: 'stop',
    ACTIVE: 'active',
}

export const INVOICE_STATUS = {
    WaitingConfirm: 'waiting-confirm',
    Approved: 'approved',
    Paid: 'paid',
    Cancelled: 'cancelled',
    Rejected: 'rejected',
    Done: 'done',
}

export const INVOICE_STATUS_OPTIONS = (t: Function) => [
    {
        label: t('waiting-confirm'),
        value: INVOICE_STATUS.WaitingConfirm,
        color: 'info',
    },
    {
        label: t('approved'),
        value: INVOICE_STATUS.Approved,
        color: 'primary',
    },
    {
        label: t('paid'),
        value: INVOICE_STATUS.Paid,
        color: 'success',
    },
    {
        label: t('cancelled'),
        value: INVOICE_STATUS.Cancelled,
        color: 'error',
    },
    {
        label: t('rejected'),
        value: INVOICE_STATUS.Rejected,
        color: 'secondary',
    },
    {
        label: t('done'),
        value: INVOICE_STATUS.Done,
        color: 'success',
    },
]

export const NEGOTIATION_STATUS = (t: Function) => [
    {
        value: 'draft',
        label: t('negotiations.draft'),
        color: 'text-gray-600 bg-gray-100',
    },
    {
        value: 'in_progress',
        label: t('negotiations.in_progress'),
        color: 'text-yellow-600 bg-yellow-100',
    },
    {
        value: 'pending_review',
        label: t('negotiations.waiting_approval'),
        color: 'text-orange-600 bg-orange-100',
    },
    {
        value: 'approved',
        label: t('negotiations.approved'),
        color: 'text-blue-600 bg-blue-100',
    },
    {
        value: 'rejected',
        label: t('negotiations.rejected'),
        color: 'text-red-600 bg-red-100',
    },
    {
        value: 'cancelled',
        label: t('negotiations.cancelled'),
        color: 'text-gray-600 bg-gray-100',
    },
    {
        value: 'completed',
        label: t('negotiations.completed'),
        color: 'text-green-600 bg-green-100',
    },
    {
        value: 'converted',
        label: t('negotiations.converted'),
        color: 'text-purple-600 bg-purple-100',
    },
]

export const NEGOTIATION_PRIORITY = (t: Function) => [
    {
        value: 'critical',
        label: t('critical'),
        color: 'text-red-600 bg-red-100',
    },
    {
        value: 'high',
        label: t('high'),
        color: 'text-orange-600 bg-orange-100',
    },

    {
        value: 'medium',
        label: t('medium'),
        color: 'text-yellow-600 bg-yellow-100',
    },

    {
        value: 'low',
        label: t('low'),
        color: 'text-green-600 bg-green-100',
    },
    {
        value: 'none',
        label: t('none'),
        color: 'text-gray-600 bg-gray-100',
    },
]

export const NEGOTIATION_TYPES = (t: Function) => [
    {
        value: 'nda',
        label: t('nda'),
        color: 'text-blue-600 bg-blue-100',
    },
    {
        value: 'quote_request',
        label: t('negotiations.quote_request'),
        color: 'text-orange-600 bg-orange-100',
    },
    {
        value: 'bom_approval',
        label: t('negotiations.bom_approval'),
        color: 'text-yellow-600 bg-yellow-100',
    },
    {
        value: 'term_negotiation',
        label: t('negotiations.term_negotiation'),
        color: 'text-green-600 bg-green-100',
    },
    {
        value: 'contract_draft',
        label: t('negotiations.contract_draft'),
        color: 'text-gray-600 bg-gray-100',
    },
    {
        value: 'other',
        label: t('negotiations.other'),
        color: 'text-gray-600 bg-gray-100',
    },
]

export const NEGOTIATION_STAGES = (t: Function) => [
    {
        value: 'initial_contact',
        label: t('negotiations.initial_contact'),
        color: 'text-blue-600 bg-blue-100',
    },
    {
        value: 'requirement_gathering',
        label: t('negotiations.requirement_gathering'),
        color: 'text-orange-600 bg-orange-100',
    },
    {
        value: 'technical_evaluation',
        label: t('negotiations.technical_evaluation'),
        color: 'text-yellow-600 bg-yellow-100',
    },
    {
        value: 'commercial_discussion',
        label: t('negotiations.commercial_discussion'),
        color: 'text-green-600 bg-green-100',
    },
    {
        value: 'legal_review',
        label: t('negotiations.legal_review'),
        color: 'text-gray-600 bg-gray-100',
    },
    {
        value: 'final_approval',
        label: t('negotiations.final_approval'),
        color: 'text-green-600 bg-green-100',
    },
    {
        value: 'contract_preparation',
        label: t('negotiations.contract_preparation'),
        color: 'text-gray-600 bg-gray-100',
    },
]
